<div [class]="'container-toast ' + (activo ? 'toast-activo' : 'toast-inactivo')">
  <img class="imagen-toast" src="https://cdn-icons-png.flaticon.com/512/665/665049.png" alt="Icono Exito">
  <span>{{mensaje}}</span>
  <button (click)="cerrarToast()">Cerrar</button>
</div>